module.exports = __webpack_public_path__ + "img/icon_map_gray.864149b6.svg";